import data from "@emoji-mart/data"
import Picker from "@emoji-mart/react"
import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { InsertEtiquetaCommandProps } from "api/Commands/InsertEtiquetaCommand"
import { useCuentaContableEmpresaAll } from "api/CuentaContableEmpresa.hook"
import Spinner from "common/components/Spinner"

import { useCuentaContableCuentaAll } from "api/CuentaContable_Cuenta.hook"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import {
  ErrorMessage,
  Field,
  Form,
  FormikErrors,
  FormikTouched,
  withFormik,
} from "formik"
import { TFunction } from "i18next"
import { DropdownChangeParams } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import { InfoModalProps } from "../CategoryManagement"

interface FormCategoryProps {
  values: InsertEtiquetaCommandProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cuentaContableId: { optionValue: any; optionLabel: any }
  }
  touched: FormikTouched<InsertEtiquetaCommandProps>
  setFieldValue: (arg: string, value: string) => void
  errors: FormikErrors<InsertEtiquetaCommandProps>
  handleCloseModal: () => void
  infoModal: InfoModalProps
  isLoading: boolean
}
const CategoryForm = ({
  values,
  touched,
  setFieldValue,
  errors,
  handleCloseModal,
  infoModal,
  isLoading,
}: FormCategoryProps) => {
  const { t } = useTranslation()
  const { cuentasContablesEmpresas: cuentasContablesBase } =
    useCuentaContableCuentaAll()
  const {
    cuentasContablesEmpresas: cuentasContables,

    cuentasContablesEmpresasRefetch: refresListaDeCuentas,
  } = useCuentaContableEmpresaAll()

  const [showEmojisPicker, setShowEmojisPicker] = useState(false)

  const handleshowPicker = () => {
    setShowEmojisPicker(!showEmojisPicker)
  }

  return (
    <Form>
      <div className='tw-flex tw-flex-row tw-text-left tw-gap-4'>
        <div className='tw-flex-col tw-w-3/4'>
          <label
            htmlFor='nombre'
            className='tw-text-base tw-text-text'
          >
            {t("categoryManagement.modal.categoryName")}
          </label>
          <InputText
            id='nombre'
            autoComplete='off'
            value={values.nombre}
            name='nombre'
            className={`tw-w-full ${
              errors?.nombre && touched?.nombre ? "!tw-border-danger" : ""
            }`}
            onChange={(e) => {
              setFieldValue("nombre", e.target.value)
            }}
          />
          <ErrorMessage
            name='nombre'
            component='div'
            className='tw-text-left tw-text-danger'
          />
        </div>
        <div className='tw-flex-col tw-w-1/4'>
          <label
            htmlFor='icono'
            className='tw-text-base tw-text-text'
          >
            {t("categoryManagement.modal.icon")}
          </label>
          <Field
            className='tw-p-2 tw-w-full tw-border-solid tw-border !tw-border-neutral-25 tw-rounded-md hover:!tw-border-primary-50 tw-leading-6'
            id='icono'
            autoComplete='off'
            name='icono'
            value={values.icono}
            onClick={handleshowPicker}
            readOnly
          />
          {showEmojisPicker && (
            <div className='tw-relative'>
              <div className='tw-absolute tw-z-20'>
                <Picker
                  theme='auto'
                  locale='es'
                  autoFocus='true'
                  previewPosition='none'
                  skinTonePosition='none'
                  categories={[
                    "frequent",
                    "people",
                    "nature",
                    "foods",
                    "activity",
                    "places",
                    "objects",
                  ]}
                  data={data}
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  onEmojiSelect={(emoji: $TSMigrationFixMe) => {
                    setFieldValue("icono", emoji.native)
                    handleshowPicker()
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='tw-text-left tw-mt-4 tw-w-full tw-relative'>
        <label
          htmlFor='cuentaContableId'
          className='tw-text-left tw-text-base tw-text-text'
        >
          {t("categoryManagement.modal.accountingAccountLabel")}
        </label>
        <DropdownCuentasContablesConModal
          cuentasContablesOptions={cuentasContables}
          dropdownValue={values.cuentaContableId}
          onChange={(newTipoDeCuenta: DropdownChangeParams) =>
            setFieldValue("cuentaContableId", newTipoDeCuenta?.value)
          }
          listaDeCuentasBase={cuentasContablesBase}
          refreshFetchData={refresListaDeCuentas}
          withCreateCuenta
        />
      </div>
      <div
        key='BotonesCrearCategoria'
        className='tw-flex tw-justify-end tw-items-center tw-mt-8'
      >
        <ButtonPrimeReact
          className='tw-p-6 !tw-bg-transparent !tw-text-primary !tw-border-0 tw-mr-4'
          onClick={() => {
            handleCloseModal()
          }}
        >
          {`${t("categoryManagement.modal.cancelButton")}`}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          className={`tw-p-6 ${
            infoModal.isEdit
              ? "!tw-bg-primary tw-min-w-24"
              : "!tw-bg-secondary hover:!tw-bg-secondary-over !tw-min-w-36"
          } tw-text-simple-10 !tw-border-none`}
          type='submit'
          disabled={isLoading}
        >
          {isLoading ? (
            <Spinner className='!tw-w-5 !tw-h-5 !tw-mt-0' />
          ) : infoModal.isEdit ? (
            t("categoryManagement.modal.saveButton")
          ) : (
            t("categoryManagement.modal.createButton")
          )}
        </ButtonPrimeReact>
      </div>
    </Form>
  )
}

const EditCreateCategoryForm = withFormik({
  mapPropsToValues: ({
    infoModal,
  }: {
    infoModal: InfoModalProps
    handleCloseModal: () => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEditEtiquetaEmpresa: $TSMigrationFixMe
    isLoading: boolean
    t: TFunction
  }) => {
    return {
      ...infoModal.data,
      nombre: infoModal.isEdit ? infoModal?.data?.nombre : null,
      icono: infoModal.isEdit ? infoModal?.data?.icono || "🏷️" : null,
      cuentaContableId: infoModal.isEdit
        ? infoModal?.data?.cuentaContableId
        : null,
    }
  },
  validationSchema: ({ t }: { t: TFunction }) => {
    return Yup.object().shape({
      nombre: Yup.string()
        .nullable()
        .required(`${t("errors.fieldEmpty")}`),
    })
  },

  handleSubmit: async (values, { props, setSubmitting }) => {
    setSubmitting(false)

    try {
      await props.addEditEtiquetaEmpresa({
        ...values,
        nombre: values?.nombre,
        icono: values?.icono,
        cuentaContableId: values?.cuentaContableId?.toString(),
      })
      props.handleCloseModal()
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
      props.handleCloseModal()
    }
  },
})(CategoryForm)

export default EditCreateCategoryForm
